import { EmailSendEventV2 } from '../email/event';

export const todoOutputs = {
  'email-send': EmailSendEventV2,
};

export type TodoOutputs = typeof todoOutputs;
